import { useTranslation } from 'react-i18next';
import { useNotifications } from 'pos-client/hooks/useNotifications.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useDeleteBlockedSlot = (handleClose?: () => void) => {
  const trpcContext = trpc.useUtils();

  const { t } = useTranslation();

  const { showSuccess, showError } = useNotifications();

  const { mutate: deleteBlockedSlot, isLoading: deleteBlockedSlotIsLoading } =
    trpc.deleteBlockedSlot.useMutation({
      onSuccess: () => {
        trpcContext.findScheduleBoardJobsAndBlockedSlots.invalidate();

        showSuccess(
          t('common.notification.success.message', {
            action: 'deleted',
            entity: 'blocked slot',
          })
        );

        return handleClose && handleClose();
      },
      onError: () => {
        showError(
          t('common.notification.error.message', {
            action: 'delete',
            entity: 'blocked slot',
          })
        );
        return handleClose && handleClose();
      },
    });

  return { deleteBlockedSlot, deleteBlockedSlotIsLoading };
};
